/**
 * Drag-to-scroll for the applied-filter chip rows on the PLP.
 *
 * On mobile widths those rows are single-line horizontal scrollers (see the
 * "applied chips live on one scrollable row" block in rendi-filters.css). A
 * touch swipe and a horizontal wheel scroll them; a plain mouse drag did not,
 * which is the only gesture left on a laptop without a horizontal wheel.
 *
 * Two things shape this file:
 *
 * Globo rebuilds the rows on every filter change, so nothing is bound to the
 * elements: the listeners sit on the document and find the row with closest().
 * There is no MutationObserver to keep in sync with the app's markup.
 *
 * Every chip is a removal control — the whole anchor removes the filter, the ×
 * inside it is decoration — so a drag must never end as a click. Past the
 * threshold the next click is swallowed in the capture phase, before it can
 * reach the anchor.
 */
(() => {
  const ROWS =
    '#gf-controls-container .globo-selected-items, #gf-tree .globo-selected-items';
  /* px of travel before a press counts as a drag rather than a click */
  const THRESHOLD = 5;

  let row = null;
  let startX = 0;
  let startScrollLeft = 0;
  let dragging = false;
  let swallowNextClick = false;

  document.addEventListener('pointerdown', (event) => {
    /* touch and pen already scroll these rows natively */
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    swallowNextClick = false;

    const candidate = event.target.closest?.(ROWS);
    /* nothing to drag when the row fits */
    if (!candidate || candidate.scrollWidth <= candidate.clientWidth) return;

    row = candidate;
    startX = event.clientX;
    startScrollLeft = candidate.scrollLeft;
    dragging = false;
  });

  document.addEventListener('pointermove', (event) => {
    if (!row) return;

    const delta = event.clientX - startX;

    if (!dragging) {
      if (Math.abs(delta) < THRESHOLD) return;
      dragging = true;
      row.dataset.rendiDragging = 'true';
      /* capture so the drag survives the pointer leaving the row */
      row.setPointerCapture?.(event.pointerId);
    }

    row.scrollLeft = startScrollLeft - delta;
    /* stops the text selection the drag would otherwise start */
    event.preventDefault();
  });

  const endDrag = () => {
    if (!row) return;
    if (dragging) {
      swallowNextClick = true;
      delete row.dataset.rendiDragging;
    }
    row = null;
    dragging = false;
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener(
    'click',
    (event) => {
      if (!swallowNextClick) return;
      swallowNextClick = false;
      if (!event.target.closest?.(ROWS)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})();
